<template>
    <UInputMenu
        :model-value="filter.selected"
        @update:model-value="onUpdate($event)"
        :search="search"
        placeholder="Select..."
        option-attribute="name"
        nullable
        by="id"
        size="lg"
    />
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'
import { UserRole } from '~/types/user'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const client = useSupabaseClient()

function onUpdate(event: any) {
    emit('update:filter', {
        ...props.filter,
        selected: event,
        value: event.id,
    })
}

async function search(q: string) {
    const { data, error } = await client.from('users')
        .select('id, name')
        .is('deleted_at', null)
        .in('role', [UserRole.medicalDirector, UserRole.doctor, UserRole.operator])
        .ilike('name', `%${q}%`)
        .order('name')

    if (error) {
        return []
    }

    return data
}
</script>